module.exports = __webpack_public_path__ + "img/dropbox.1aa1a94b.png";